import React, { useState, useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { API } from "aws-amplify";

import { via } from "../../Utils/constants";
import {
  validatorField,
  validateTextOnlyAlphanumeric,
  validateTextOnlyAlphanumericVia,
} from "../../Utils/validators";

import ErrorCustom from "../../Components/errorCustom";

interface Params {
  department?: object | null;
  province?: object | null;
}

export const Addressv2 = ({
  setNameUbigeo,
  nameUbigeo,
  setNameVia,
  dataRedux,
}: any) => {
  const methods: any | undefined = useFormContext();
  const [loading, setLoading] = useState<boolean>(false);
  const [department, setDepartment] = useState<null>(null);
  const [dataDepart, setDataDepart] = useState([]);
  const [dataProv, setDataProv] = useState([]);
  const [dataDist, setDataDist] = useState([]);
  const inputEl = useRef(null);
  const [ touchedForm, setTouchedForm ] = useState(false)

  const [isFill, setIsFill] = useState<boolean>(false);
  const isEmptyValue = (): boolean => {
    const elem = inputEl.current || null;
    if (elem) {
      const input = (elem as HTMLElement).querySelector("input");
      return input ? input.value.trim().length > 0 : true;
    }

    return true;
  };

  const setFill = () => {
    setIsFill(!isEmptyValue());
  };

  useEffect(() => {
    setFill();
  }, []);

  useEffect(() => {
    getUbigeos(null, null, null);
  }, []);

  const getUbigeos = async (
    depart: object | null,
    prov: object | null,
    filterBy: string | null
  ) => {
    setLoading(true);
    let params: Params = {};
    if (depart) {
      params.department = depart;
    }
    if (prov) {
      params.province = prov;
    }

    const response = await API.post("api-rentas", "/ubigeos", {
      body: params,
      headers: {},
    });

    if (response.status) {
      const { data } = response;
      if (filterBy && typeof filterBy === "string") {
        if (filterBy === "department") {
          setDataProv(data);
          setDataDist([]);
          setDepartment(depart as any);
        } else if (filterBy === "province") {
          setDataDist(data);
        }
      } else {
        setDataDepart(data);
      }
    }
    setLoading(false);
  };

  interface MyObject {
    department: object | null;
    province: string;
    district: string;
    name: string;
    number: string;
    apartment: string;
    urbanization: string;
    reference: string;
    type: string;
  }

  const myObject: MyObject = {
    department: {},
    province: "",
    district: "",
    name: "",
    number: "",
    apartment: "",
    urbanization: "",
    reference: "",
    type: "",
  };

  const {
    department: departamento,
    province,
    district,
    name,
    number: numero,
    apartment,
    urbanization,
    reference,
    type: tipo,
  } = dataRedux || myObject;


  useEffect(() => {
    if(departamento){
      if(dataDepart && Object.keys(departamento).length !== 0 && !touchedForm){
        methods.setValue('addressv2.department', departamento,  { shouldValidate : true } )
        getUbigeos(departamento, null, "department");
      }
    }
  }, [dataDepart])

  useEffect(() => {
    if(province){
      if(dataProv && Object.keys(province).length !== 0 && !touchedForm){
        getUbigeos(departamento, province, "province");
        methods.setValue('addressv2.province', province,  { shouldValidate : true } )
      }
    }
  }, [dataProv])

  useEffect(() => {
    if(district){
      if(dataDist && Object.keys(district).length !== 0 && !touchedForm){
        methods.setValue('addressv2.district', district,  { shouldValidate : true } )
      }
    }
  }, [dataDist]);

  useEffect(() => {
    if(tipo){
      methods.setValue('addressv2.type', tipo,  { shouldValidate : true } )
    }
  }, [tipo])
  const handleChangeDepart = (e: any) => {
    methods.setValue('addressv2.province', null)
    methods.setValue('addressv2.distric', null)
    setTouchedForm(true)
    const depart = e.target.value;
    const index = e.target.selectedIndex;
    const nameDepart = e.target[index].text;
    setNameUbigeo({
      ...nameUbigeo,
      department: nameDepart,
      province: "",
      district: "",
    });
    getUbigeos(depart, null, "department");
    const provinceSelect = document.getElementsByName(
      "addressv2.province"
    )[0] as HTMLSelectElement;
    const districtSelect = document.getElementsByName(
      "addressv2.district"
    )[0] as HTMLSelectElement;

    if (provinceSelect && districtSelect) {
      provinceSelect.selectedIndex = 0;
      districtSelect.selectedIndex = 0;
    }
  };

  const handleChangeProv = (e: any) => {
    const prov = e.target.value;
    const index = e.target.selectedIndex;
    const nameProv = e.target[index].text;
    setNameUbigeo({
      ...nameUbigeo,
      province: nameProv,
      district: "",
    });
    getUbigeos(department, prov, "province");
    const districtSelect = document.getElementsByName(
      "addressv2.district"
    )[0] as HTMLSelectElement;
    if (districtSelect) {
      districtSelect.selectedIndex = 0;
    }
  };

  const handleChangeDist = (e: any) => {
    const index = e.target.selectedIndex;
    const nameDist = e.target[index].text;
    setNameUbigeo({
      ...nameUbigeo,
      district: nameDist,
    });
  };

  const handleChangeVia = (e: any) => {
    const nombreVia = e.target.selectedOptions[0].text;
    setNameVia({
      via: nombreVia,
    });
  };

  const number: any | undefined = methods.errors.addressv2
    ? methods.errors.addressv2.number
    : undefined;
  const departmentError: any | undefined = methods.errors.addressv2
    ? methods.errors.addressv2.department
    : undefined;
  const provinceError: any | undefined = methods.errors.addressv2
    ? methods.errors.addressv2.province
    : undefined;
  const districtError: any | undefined = methods.errors.addressv2
    ? methods.errors.addressv2.district
    : undefined;
  const typeError: any | undefined = methods.errors.addressv2
    ? methods.errors.addressv2.type
    : undefined;
  const addressError: any | undefined = methods.errors.addressv2
    ? methods.errors.addressv2.name
    : undefined;

  return (
    <>
      <div className="clientForm__control input-field">
        <select
          className={departmentError ? " is-error" : ""}
          name="addressv2.department"
          onChange={(e) => handleChangeDepart(e)}
          ref={methods.register({ validate: validatorField })}
        >
          <option value={""} disabled selected>
            Departamento
          </option>

          {dataDepart.map((item: any, index) => (
            <option key={index} value={item.codigo}>
              {item.descripcion.substr(0, 1).toUpperCase() +
                item.descripcion.substr(1).toLowerCase()}
            </option>
          ))}
        </select>
        <ErrorCustom errors={methods.errors} name="addressv2.department" />
      </div>

      <div className="clientForm__control input-field">
        <select
          className={provinceError ? " is-error" : ""}
          name="addressv2.province"
          onChange={(e) => handleChangeProv(e)}
          ref={methods.register({ validate: validatorField })}
        >
          <option value={""} disabled selected>
            Provincia
          </option>
          {dataProv.map((item: any, index) => (
            <option key={index} value={item.codigo}>
              {item.descripcion.substr(0, 1).toUpperCase() +
                item.descripcion.substr(1).toLowerCase()}
            </option>
          ))}
        </select>
        <ErrorCustom errors={methods.errors} name="addressv2.province" />
      </div>

      <div className="clientForm__control input-field">
        <select
          className={"browser-default" + (districtError ? " is-error" : "")}
          name="addressv2.district"
          onChange={(e) => handleChangeDist(e)}
          ref={methods.register({ validate: validatorField })}
        >
          <option value={""} disabled selected>
            Distrito
          </option>

          {dataDist.map((item: any, index) => (
            <option key={index} value={item.codigo}>
              {item.descripcion.substr(0, 1).toUpperCase() +
                item.descripcion.substr(1).toLowerCase()}
            </option>
          ))}
        </select>
        <ErrorCustom errors={methods.errors} name="addressv2.district" />
      </div>

      <div className="clientForm__control__inputSelect">
        <select
          className={"browser-default" + (typeError ? " is-error" : "")}
          name="addressv2.type"
          onChange={(e) => handleChangeVia(e)}
          ref={methods.register({ validate: validatorField })}
        >
          <option value="" selected disabled>
            Tipo de vía
          </option>
          {via.map((item, index) => (
            <option key={index} value={item.value}>
              {item.text}
            </option>
          ))}
        </select>
        <div
          ref={inputEl}
          className={
            "clientForm__control input-field" + (isFill ? " is-fill" : "")
          }
        >
          <input
            id="name"
            name="addressv2.name"
            className={addressError ? " is-error" : ""}
            ref={methods.register({
              validate: validateTextOnlyAlphanumericVia,
            })}
            defaultValue={name}
            autoComplete="off"
            maxLength={25}
            type="text"
          />
          <label htmlFor="addressv2.name" className={ name ? "active" : "false"}>Dirección</label>
          <ErrorCustom errors={methods.errors} name="addressv2.name" />
        </div>
      </div>

      <div className="group-form">
        <div
          ref={inputEl}
          className={
            "clientForm__control input-field" + (isFill ? " is-fill" : "")
          }
        >
          <input
            id="number"
            name="addressv2.number"
            className={number ? " is-error" : ""}
            ref={methods.register({ validate: validateTextOnlyAlphanumeric })}
            defaultValue={numero}
            autoComplete="off"
            maxLength={10}
            type="text"
          />
          <label htmlFor="addressv2.number" className={ numero ? "active" : "false"}>Nro/Mz/Lote</label>
          <ErrorCustom errors={methods.errors} name="addressv2.number" />
        </div>

        <div
          ref={inputEl}
          className={
            "clientForm__control input-field is-optional" +
            (isFill ? " is-fill" : "")
          }
        >
          <input
            id="apartment"
            name="addressv2.apartment"
            ref={methods.register}
            defaultValue={apartment}
            autoComplete="off"
            maxLength={9}
            type="text"
          />
          <label htmlFor="addressv2.apartment" className={ apartment ? "active" : "false"}>Dpto/Interior</label>
          <div>(opcional)</div>
          <ErrorCustom errors={methods.errors} name="addressv2.apartment" />
        </div>
      </div>

      <div
        ref={inputEl}
        className={
          "clientForm__control input-field is-optional" +
          (isFill ? " is-fill" : "")
        }
      >
        <input
          id="urbanization"
          name="addressv2.urbanization"
          ref={methods.register}
          defaultValue={urbanization}
          autoComplete="off"
          maxLength={30}
          type="text"
        />
        <label htmlFor="addressv2.urbanization" className={ urbanization ? "active" : "false"}>Urbanización</label>
        <div>(opcional)</div>
        <ErrorCustom errors={methods.errors} name="addressv2.urbanization" />
      </div>

      <div
        ref={inputEl}
        className={
          "clientForm__control input-field is-optional" +
          (isFill ? " is-fill" : "")
        }
      >
        <input
          id="reference"
          name="addressv2.reference"
          ref={methods.register}
          defaultValue={reference}
          autoComplete="off"
          maxLength={50}
          type="text"
        />
        <label htmlFor="addressv2.reference" className={ reference ? "active" : "false"}>Referencia</label>
        <div>(opcional)</div>
        <ErrorCustom errors={methods.errors} name="addressv2.reference" />
      </div>
    </>
  );
};
